import { Module } from 'vuex';

import { RootState } from '@/store/types';

import actions from './actions';
import getters from './getters';
import initialState from './initialState';
import mutations from './mutations';
import { BaseWorkflowStoreModuleState } from './types';

const vuexModule: Module<BaseWorkflowStoreModuleState, RootState> = {
  namespaced: true,
  state: initialState() as BaseWorkflowStoreModuleState,
  mutations,
  actions,
  getters,
};

export default vuexModule;
